import React from "react";
import { Button } from "antd";
import { FormattedMessage } from "react-intl";
import { WhatsappSVG } from "../WhatsappSVG";
import { ActionFooter } from "../components/ActionFooter";

export function WhatsappSuccessScreen({
	primaryColor,
	captureResponse,
	handleModalClose,
}) {
	return (
		<>
			<div className="bg-white min-h-[596px] flex flex-col items-center justify-center">
				<div className="mb-8 w-80 h-auto">
					<div className="w-full h-auto [&>svg]:w-full [&>svg]:h-auto [&>svg]:max-w-80">
						<WhatsappSVG color={primaryColor} />
					</div>
				</div>
				<div className="text-center my-4">
					<h3 className="text-lg font-medium mb-2">
						<FormattedMessage
							id="whatsapp.success_title"
							defaultMessage="Link de captura enviado pelo WhatsApp"
						/>
					</h3>
				</div>
			</div>
			<ActionFooter>
				<Button
					className="border-0 text-white !px-12 shadow-none"
					size="large"
					shape="round"
					type="primary"
					onClick={handleModalClose}
				>
					<FormattedMessage id="close" />
				</Button>
			</ActionFooter>
		</>
	);
}
